<div class="col-sm-12 nopadding-mobile">
  <div class="profile-sec-wrap-alt">
    <!-- Working ours title section -->
    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
      <div class="panel-sub-title-alt">{{dayOfWorkLabel}}</div>

      <a class="btn-main-proceed centered" (click)="addItem()">Add Slot</a>
    </div>

    <!-- Working hours field wrapper -->
    <div class="col-lg-9 col-md-9 col-sm-9 col-xs-12 push-down-5 push-up-5">
      <div class="profile-content-alt" *ngIf="noWorkingHours()">
        <div class="mb-table-lg centered">No working hours selected for this day.</div>
      </div>

      <!-- Working hours repeatable -->
      <div *ngFor="let item of selectedItems">
        <div class="panel-min" *ngIf="item.dayOfWeek == dayOfWeek">
          <div class="col-lg-11 col-md-10 col-sm-10 col-xs-10 nopadding">
            <div class="col-xs-6 nopadding-right">
              <div class="form-elem-field-alt">
                <select [(ngModel)]="item.startTime" class="select-small">
                  <option *ngFor="let slotItem of slotTimes">{{slotItem.startTime}}</option>
                </select>
              </div>
            </div>

            <div class="col-xs-6 nopadding-right">
              <div class="form-elem-field-alt">
                <select [(ngModel)]="item.endTime" class="select-small">
                  <option *ngFor="let slotItem of slotTimes">{{slotItem.endTime}}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-lg-1 col-sm-2 col-xs-2 push-down-15">
            <a class="close-btn" (click)="removeItem(item)"><i class="glyphicon glyphicon-remove"></i></a>
          </div>

          <div class="clear"></div>
        </div>
      </div>
      <!-- Working hours repeatable -->
    </div>
    <!-- Working hours field wrapper -->
    <div class="clear"></div>
  </div>
</div>
